import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { Label, Select, Checkbox } from '@/components/FormElements';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import controlStyles from '@/components/FormElements/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SettingsDuotoneIcon = function SettingsDuotoneIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H21C21.5523 8 22 7.55228 22 7C22 6.44772 21.5523 6 21 6H3Z",
      fill: "#C3C9D1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3 16C2.44772 16 2 16.4477 2 17C2 17.5523 2.44772 18 3 18H21C21.5523 18 22 17.5523 22 17C22 16.4477 21.5523 16 21 16H3Z",
      fill: "#C3C9D1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 10C9.65685 10 11 8.65685 11 7C11 5.34315 9.65685 4 8 4C6.34315 4 5 5.34315 5 7C5 8.65685 6.34315 10 8 10Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16 20C17.6569 20 19 18.6569 19 17C19 15.3431 17.6569 14 16 14C14.3431 14 13 15.3431 13 17C13 18.6569 14.3431 20 16 20Z",
      fill: "black"
    })]
  }));
};

SettingsDuotoneIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const DEFAULT_CHART_TYPE = 'semicircle';
const CHART_TYPE_OPTIONS = [{
  value: 'semicircle',
  label: 'Default'
}, {
  value: 'grafana',
  label: 'Banded Gauge'
}];

const WidgetEditFormGaugeChartType = _ref => {
  let {
    nameSpace,
    config,
    openButtonVariant,
    onChange
  } = _ref;
  const gradualColorsFieldId = `${nameSpace}-gradual-colors`;
  const centerTextFieldId = `${nameSpace}-center-text`;
  const {
    chartType = DEFAULT_CHART_TYPE
  } = config;
  return /*#__PURE__*/_jsxs(RevealPill, {
    label: "Settings",
    activeState: /*#__PURE__*/_jsx(SettingsDuotoneIcon, {}),
    openButtonVariant: openButtonVariant,
    children: [/*#__PURE__*/_jsx(Label, {
      className: parentStyles.formField,
      text: "Chart Type",
      children: /*#__PURE__*/_jsx(Select, {
        defaultValue: chartType,
        onChange: evt => {
          var _evt$currentTarget;

          return onChange('', {
            chartType: ((_evt$currentTarget = evt.currentTarget) === null || _evt$currentTarget === void 0 ? void 0 : _evt$currentTarget.value) || ''
          });
        },
        children: CHART_TYPE_OPTIONS.map((option, idx) => /*#__PURE__*/_jsx("option", {
          value: option.value,
          children: option.label
        }, `${option.value}-${idx}`))
      })
    }), /*#__PURE__*/_jsx(Checkbox, {
      id: centerTextFieldId,
      className: parentStyles.formField,
      checked: config.isCenterTextHidden ?? false,
      onChange: evt => onChange('', {
        isCenterTextHidden: evt.target.checked
      }),
      children: /*#__PURE__*/_jsx("span", {
        className: controlStyles.optionsInputHeading,
        children: "Hide center text"
      })
    }), /*#__PURE__*/_jsxs(Checkbox, {
      id: gradualColorsFieldId,
      className: parentStyles.formField,
      checked: config.hasGradualColors,
      onChange: evt => onChange('', {
        hasGradualColors: evt.target.checked
      }),
      children: [/*#__PURE__*/_jsx("span", {
        className: controlStyles.optionsInputHeading,
        children: "Gradual Colors"
      }), /*#__PURE__*/_jsx("span", {
        className: clsx(controlStyles.optionsInputSubHeading, controlStyles['optionsInputSubHeading--expanded']),
        children: "Gradually transition between range colors"
      })]
    })]
  });
};

export default WidgetEditFormGaugeChartType;